import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../Form/Button';
import ButtonPrimary from '../Form/ButtonPrimary';

interface LinkProfileProps {
  label: string;
  path?: string;
  active?: boolean;
  icon?: any;
  onClick?: CallableFunction;
  disabled?: boolean;
}

const LinkProfile = ({
  label,
  path,
  active = false,
  icon,
  onClick = () => {},
  disabled = false
}: LinkProfileProps) => {

  const navigate = useNavigate();

  return (
    <>
      { active
        ?
          <ButtonPrimary 
            outline 
            onClick={() => {}} 
            className='w-full w-full ring-inset pointer-events-none'>
            <div className='flex w-full text-sm gap-0.5 md:gap-1 justify-center md:justify-start text-nowrap'>
              {icon && <div>{icon}</div> }
              <span>{label}</span>
            </div>
          </ButtonPrimary>
        :
          <Button onClick={() => path ? navigate(path) : onClick()} 
            disabled={disabled}
            className={`w-full w-full ring-inset bg-white md:bg-transparent text-gray-500 md:ring-transparent text-nowrap`}>
            <div className='flex w-full text-sm gap-0.5 md:gap-1 justify-center md:justify-start'>
              {icon && <div>{icon}</div> }
              <span>{label}</span>
            </div>
          </Button>
      }
    </>
  )
}

export default LinkProfile;